// extracted by mini-css-extract-plugin
export var closeButton = "_e2-1";
export var closeX = "_e2-3";
export var container = "_e2-0";
export var image = "_e2-2";